import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, LazyAction, type LazyComponent } from "owa-bundling";
import type HipCheckModalProps from "./types/HipCheckModalProps";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OwaHipCheckModal" */ "./lazyIndex"), { name: "OwaHipCheckModal" });

export const ArkoseModal: LazyComponent<HipCheckModalProps, unknown, void> = createLazyComponent(lazyModule, m => {
    return m.ArkoseModal;
});

export const lazyHandleHipException: LazyAction<typeof lazyIndex.handleHipException, LazyModule<typeof lazyIndex>> = new LazyAction(lazyModule, m => {
    return m.handleHipException;
});

export const lazyCheckAndHandleHipException: LazyAction<typeof lazyIndex.checkAndHandleHipException, LazyModule<typeof lazyIndex>> = new LazyAction(lazyModule, m => {
    return m.checkAndHandleHipException;
});

export const lazyFlushHipDatapointQueue: LazyAction<typeof lazyIndex.flushHipDatapointQueue, LazyModule<typeof lazyIndex>> = new LazyAction(lazyModule, m => {
    return m.flushHipDatapointQueue;
});
